var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParcoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 566.92 137.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#595657;}.cls-1,.cls-2{fill-rule:evenodd;stroke-width:0px;}.cls-2{fill:url(#GradientFill_1);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_1",
    x1: 273.32,
    y1: -2.15,
    x2: 259.63,
    y2: 146.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009dda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#0075a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#005580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#004267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003b5f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.2,37.51l34.46-.11c29.91,0,30.07,45.62,0,45.62H18.2v-45.51h0ZM52.66,99.76c54.45-.33,54.29-79.15,0-79.15-17.39,0-35.27.16-52.66.16v113.94h18.2v-34.95h34.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.9,134.7h19.34l-29.67-66.25c-4.48,3.22-8.88,6.57-13.18,10.04l-.92.75c7.35,17.17,7.52,18.34,24.43,55.46Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.23,131.45l-33.97-37.87c22.43-3.25,30.88-19.18,30.88-35.43,0-18.29-12.56-35.54-36.56-37.11-4.63,1.2-9.24,2.51-13.82,3.91-14,4.3-27.69,9.54-40.95,15.76l-1.8.85v93.13h18.2v-39.33h24.05l34.62,39.33h21.29l-1.95-3.25h0ZM282,37.51c14.96,0,21.62,10.73,21.62,20.97s-6.66,20.32-21.78,20.32h-34.62v-41.28h34.78Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M429.42,107.56c-7.96,7.97-19.67,12.35-30.23,12.35-29.42,0-41.77-20.64-41.93-41.45-.16-20.97,13-42.26,41.93-42.26,10.56,0,21.29,3.74,29.42,11.7l12.19-11.7c-11.54-11.54-26.33-17.23-41.61-17.23-40.63,0-60.14,29.74-59.98,59.65.16,29.91,18.69,58.35,59.98,58.35,15.93,0,31.04-5.36,42.75-16.91l-12.52-12.52Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M509.06,18.82c-34.29,0-58.51,25.03-58.51,59.65,0,29.91,18.69,58.67,58.19,58.67s58.19-28.12,58.19-58.84-19.02-59.32-57.86-59.49h0ZM468.59,78.63c0-24.87,14.14-43.23,40.47-43.23,27.79.49,39.82,22.27,39.82,43.23s-11.86,41.77-40.14,41.77-39.82-21.62-40.15-41.77Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M270.52,20.91c50.31-15.45,107.4-19.83,171.3-13.14-75.71-13.65-143.21-9.32-202.51,13.01-3.46,1.3-6.89,2.67-10.3,4.09-18.25,7.64-35.69,17.04-52.33,28.2l-14.47-32.31h-19.83l-51.03,113.94h19.34c17.17-22.85,36.18-42.68,57.05-59.5,4.6-3.71,9.29-7.27,14.07-10.69,14.86-10.63,30.6-19.83,47.21-27.63,13.28-6.23,27.12-11.56,41.51-15.98h0ZM162.5,63.16c-11.24,8.46-22.1,17.77-32.57,27.94,4.3-9.99,8.95-20.87,22.36-51.1,4.2,9.47,7.52,17.01,10.21,23.16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcoLogo);
export default __webpack_public_path__ + "static/media/parco-logo.5b6d13284bb7545b9f9175d11a736b8c.svg";
export { ForwardRef as ReactComponent };